import { Link } from 'react-router-dom';
import { TECH_LOGOS, type CaseStudy } from '../casestudies/caseStudiesData';

interface CaseStudyCardProps {
  study: CaseStudy;
}

export default function CaseStudyCard({ study }: CaseStudyCardProps) {
  return (
    <Link
      to={`/case-studies/${study.slug}`}
      className="group flex flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
    >
      <div className="relative aspect-[16/9] overflow-hidden bg-[#0a1628]">
        <img
          src={study.heroImage}
          alt={`${study.client} case study`}
          className="absolute inset-0 h-full w-full object-cover object-right transition-transform duration-500 group-hover:scale-105"
        />
        {['enterprise-print-analytics', 'education-marketing-dashboard'].includes(study.slug) && (
          <div className="absolute inset-0 bg-gradient-to-r from-[#071426]/65 via-[#123a66]/20 to-transparent" />
        )}
        <div className="absolute left-4 top-4">
          <span className="rounded-full bg-[#0a1628]/70 px-3 py-1.5 text-xs font-semibold text-white backdrop-blur">
            {study.industry}
          </span>
        </div>
      </div>

      <div className="flex flex-1 flex-col p-8">
        <h2 className="mb-3 text-xl font-semibold text-gray-900 transition group-hover:text-[#1a4e94]">
          {study.client}
        </h2>
        <p className="mb-6 flex-1 text-[15px] leading-relaxed text-gray-500">{study.cardSummary}</p>
        <div className="mb-6 flex min-h-5 items-center gap-4">
          {study.technologies.slice(0, 4).map((technology) =>
            TECH_LOGOS[technology] ? (
              <img
                key={technology}
                src={TECH_LOGOS[technology]}
                alt={`${technology} logo`}
                title={technology}
                className="h-5 w-5 object-contain opacity-80"
              />
            ) : null
          )}
        </div>
        <span className="inline-flex items-center gap-1.5 text-sm font-bold uppercase tracking-wide text-[#1a4e94]">
          Read the case study
          <svg className="h-4 w-4 transition-transform group-hover:translate-x-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
          </svg>
        </span>
      </div>
    </Link>
  );
}
